export const load = () => ({
	title:
		'Insulating Government Buildings: The Indow Solution for Historic Preservation',
	description:
		'Discover how Indow inserts provide energy efficiency, comfort, and draft reduction for government and historic buildings, preserving character while cutting costs. ',
	showTitle: true,
});
